import { frontendURL } from '../../../helper/URLHelper';
import ContactsIndex from './pages/ContactsIndex.vue';
import ContactManageView from './pages/ContactManageView.vue';
import ContactDddAssignments from './pages/ContactDddAssignments.vue';
import ContactPortfolioIndex from './pages/ContactPortfolioIndex.vue';
import ContactPortfolioDistribution from './pages/ContactPortfolioDistribution.vue';
import { FEATURE_FLAGS } from '../../../featureFlags';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.CRM,
  permissions: ['administrator', 'agent', 'custom_role', 'contact_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts'),
    component: ContactsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'contacts_dashboard',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'segments/:segmentId',
        name: 'contacts_segments_dashboard',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'labels/:label',
        name: 'contacts_labels_dashboard',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'active',
        name: 'contacts_dashboard_active',
        component: ContactsIndex,
        meta: commonMeta,
      },
      {
        path: 'portfolio',
        name: 'contacts_portfolio',
        component: ContactPortfolioIndex,
        meta: commonMeta,
      },
      {
        path: 'portfolio/distribution',
        name: 'contacts_portfolio_distribution',
        component: ContactPortfolioDistribution,
        meta: commonMeta,
      },
      {
        path: 'ddd-assignments',
        name: 'contacts_ddd_assignments',
        component: ContactDddAssignments,
        meta: {
          permissions: ['administrator'],
        },
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/contacts/:contactId'),
    component: ContactManageView,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'contact_profile_dashboard',
        component: ContactManageView,
        meta: commonMeta,
      },
      {
        path: 'segments/:segmentId',
        name: 'contacts_edit_segment',
        component: ContactManageView,
        meta: commonMeta,
      },
      {
        path: 'labels/:label',
        name: 'contacts_edit_label',
        component: ContactManageView,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/contacts/portfolio'),
    name: 'contacts_portfolio',
    meta: commonMeta,
    component: ContactPortfolioIndex,
  },
  {
    path: frontendURL('accounts/:accountId/contacts/portfolio/distribution'),
    name: 'contacts_portfolio_distribution',
    meta: commonMeta,
    component: ContactPortfolioDistribution,
  },
  {
    path: frontendURL('accounts/:accountId/contacts/ddd-assignments'),
    name: 'contacts_ddd_assignments',
    meta: {
      featureFlag: FEATURE_FLAGS.CRM,
      permissions: ['administrator'],
    },
    component: ContactDddAssignments,
  },
];
